import { useEffect, useRef, useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { defaultNS, useTranslation } from '@/lib/i18n';
interface InputDayProps {
  value: string;
  year: string | null;
  month: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}
const InputDay = ({
  value,
  year,
  month,
  onChange,
  placeholder,
  disabled = false,
  className
}: InputDayProps) => {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'component.inputDay'
  });
  const getDaysInMonth = (year: string | null, month: string | null) => {
    if (!month) {
      return 31;
    }
    // 年指定がない＆月が2月の場合は、年がわからないと日数がわからないので最長である29日までを固定で表示しておく
    if (!year && month === '2') {
      return 29;
    }
    return new Date(year ? Number(year) : new Date().getFullYear(), Number(month), 0).getDate();
  };
  const days: {
    value: string;
    label: string;
  }[] = Array.from({
    length: getDaysInMonth(year, month)
  }, (_, i) => {
    const day = (i + 1).toString();
    return {
      value: day,
      label: `${day}${t('suffix')}`
    };
  });

  // 選択された項目を参照するための ref
  const selectedItemRef = useRef<HTMLDivElement | null>(null);

  // ドロップダウンの開閉状態を管理
  const [open, setOpen] = useState(false);

  // ドロップダウンが開かれたときに選択された項目にスクロールする
  useEffect(() => {
    if (open && selectedItemRef.current) {
      selectedItemRef.current.scrollIntoView({
        block: 'start'
      });
    }
  }, [open]);
  return <Select disabled={disabled} onValueChange={onChange} value={value} open={open} onOpenChange={setOpen}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder || t('placeholder')} />
      </SelectTrigger>
      <SelectContent>
        {days.map(({
        value: dayValue,
        label
      }) => <SelectItem key={dayValue} value={dayValue} ref={dayValue === value ? selectedItemRef : null}>
            {label}
          </SelectItem>)}
      </SelectContent>
    </Select>;
};
export default InputDay;